<template>
  <modal v-model="show">
    <p>Уважаеми клиенти,</p>
    <br/>
    <p>Във връзка с влизането в сила от 1 юли 2022 г. на увеличението на размера и обхвата на ТОЛ таксите за товарни автомобили (одобрено от Министерски съвет с промените в Тарифата за таксите, които се събират за преминаване и ползване на републиканската пътна мрежа), се налага и неизбежна актуализация на нашата Такса гориво и пътни такси. Съгласно т. 39 от Общите условия от 1 юли 2022 г. тя се увеличава с 3,5% с което общият размер й размер се променя на 27%.</p>
    <p>С разбиране към усложнената ситуация за всички, взехме решение през м. юли да се откажем от актуализация на инфлационната компонента в таксата, въпреки регистрираната от НСИ допълнителна инфлация. Така продължаваме да следваме последователната си политиката за актуализация на цените под средния тренд за пазара с грижа към нашите клиенти и партньори.</p>
    <p>Припомняме също така, че през последните месеци като част от транспортния бранш в България вложихме всички възможни усилия за преговори с държавата за постигане на компромисно решение за увеличение на ТОЛ таксите и ограничаване на негативния ефект за нашите клиенти и крайните потребители.</p>
    <p>Ако имате допълнителни въпроси, можете да се свържете със своя търговец или със специалистите Обслужване на клиенти в нашия кол център на *5015 и <a href="mailto:orders@transpress.bg">orders@transpress.bg</a></p>
    <br/>
    <p>Благодарим Ви за разбирането!</p>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal
  },
  props: ['value'],
  data () {
    return {
      show: this.value
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('input', val);
    }
  }
}
</script>